(function() {
    const trackingUtils = require('../modules/utils/tracking.utils');
    const tagManagement = require('../modules/utils/tag_management.utils');
    const userAccountError = require('../modules/users/user_account_error');
    const postBookingEventController = require('../modules/handlers/post_booking');
    const myTripsUtils = require('../modules/utils/my_trips.utils');
    const tripdetailsStorageUtils = require('../modules/utils/tripdetails_storage.utils');
    const xsellFindBookingFactory = require('components/cross_selling/find_booking/js/main');
    const myTripsFactory = require('components/user_area/my_trips/js/main');
    const downloadAppBannerFactory = require('components/app_download/download_app_banner/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');
    const pbAncillariesCollection = require('od-modules/collections/pb_ancillaries_collection/collection');
    const itineraryStatusFactory = require('components/user_area/itinerary_status/js/main');
    const itineraryStatusTracking = require('../tracking/itinerary_status');

    Odigeo.Router.handlers.mytrips = function() {
        var pageName = 'mytrips';
        const BOOKING_INFO = 'bookingInfo';
        var $page = $('#page');
        var $myInfo = $('#myInfo');
        var widgets = Odigeo.autoloadWidgetsAsync({
            getUsersManager: ['users-manager', 'usersmanager'],
            getPostBookingSeats: ['post-booking-seats', 'post_booking_seats'],
            getPostBookingBags: ['post-booking-bags', 'post_booking_bags'],
        });
        const widgetLoader = createWidgetLoader({
            xsellFindBooking: ['my-trips-with-find-booking', xsellFindBookingFactory],
            myTrips: ['my-trips', myTripsFactory],
            downloadAppBanner: ['download-app-banner', downloadAppBannerFactory],
            itineraryStatus: ['my-trips-itinerary-status', itineraryStatusFactory],
        });

        let airlineList;
        $page.removeClass().addClass(pageName);

        Odigeo.Router.eventController = $.extend(Odigeo.Router.eventController, Odigeo.Router.handlers.userEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
            Odigeo.Router.handlers.globalEventController, Odigeo.Router.handlers.searchSummaryEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
            postBookingEventController, {
                globalEvents: {
                    'session:loginexpiration': 'onLoginExpiration',
                },
                viewEvents: {
                    'my-trips:changePageTitle': 'onChangePageTitle',
                    'my-trips:showCanFindBooking': 'onShowCanFindBooking',
                    'my-trips:hideCanFindBooking': 'onHideCanFindBooking',
                    'my-trips:hideManageMyBookingBox': 'onHideManageMyBookingBox',
                    'my-trips:requestManageMyBookingToken': 'onRequestManageMyBookingToken',
                    'my-trips:onGoToTappedOneTripTracking': 'goToTappedOneTripTracking',
                    'global:onGetDataError': 'onGetDataError',
                    'global:userLogout': 'onGoToHomePage',
                    'users-manager:getMyTripsWithError': 'onGetDataError',
                    'users-manager:getMyTripsError': 'onGetDataError',
                    'users-manager:getMyTripsOk': 'onGetMyTripsOk',
                    'users-manager:getEncryptedTripOk': 'onGetEncryptedTripOk',
                    'users-manager:getEncryptedTripWithError': 'onGetEncryptedTripError',
                    'users-manager:getEncryptedTripError': 'onGetEncryptedTripError',
                    'baggage_wrapper_postbooking:loadBags': 'onLoadBags',
                    'baggage_wrapper_postbooking:hideAncillaryCTA': 'hideAncillaryCTA',
                    'bags_and_seats_offline:loadBags': 'onLoadBags',
                    'seats_wrapper_postbooking:loadSeats': 'onLoadSeats',
                    'seats_wrapper_postbooking:hideAncillaryCTA': 'hideAncillaryCTA',
                    'bags_and_seats_offline:loadSeats': 'onLoadSeats',
                    'post-booking-bags:bagsAvailable': 'onBagsAvailable',
                    'post-booking-seats:seatsAvailable': 'onSeatsAvailable',
                    'my-trips:changeCategoryTracking': 'onChangeCategoryTracking',
                    'my-trips:dataTrackNoTrips': 'onDataTrackNoTrips',
                    'users-manager:getManageBookingTokenOk': 'onGetManageBookingToken',
                    'users-manager:getManageBookingTokenWithError': 'onGetManageBookingToken',
                    'users-manager:getManageBookingTokenError': 'onGetManageBookingToken',
                },
                eventHandlers: {
                    onLoadBags: function(bookingInfo) {
                        tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, bookingInfo);
                        widgets.getPostBookingBags().execute('open');
                        pbAncillariesCollection.loadTripBags(bookingInfo);
                    },
                    onLoadSeats: function(bookingInfo) {
                        tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, bookingInfo);
                        widgets.getPostBookingSeats().execute('open');
                        pbAncillariesCollection.loadTripSeats(bookingInfo);
                    },
                    hideAncillaryCTA: function(type) {
                        widgetLoader.get('myTrips').execute('hideAncillaryCTA', type);
                    },
                    onBagsAvailable: function(ancillaryInfo) {
                        var bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
                        Odigeo.Session.set('ancillaryInfo', JSON.stringify(ancillaryInfo.availableAncillariesOptionsDTO));
                        Odigeo.trigger('my-trips:openAddBags', bookingInfo, ancillaryInfo.availableAncillariesOptionsDTO);
                    },
                    onSeatsAvailable: function(ancillaryInfo) {
                        var bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
                        Odigeo.Session.set('ancillaryInfo', JSON.stringify(ancillaryInfo.availableAncillariesOptionsDTO));
                        Odigeo.trigger('my-trips:openAddSeats', bookingInfo, ancillaryInfo.availableAncillariesOptionsDTO);
                    },
                    onGoToHomePage: function() {
                        Odigeo.Utils.goToApplicationHome();
                    },

                    onChangePageTitle: function() {
                        _changePageTitle();
                    },

                    onGetDataError: function(data) {
                        userAccountError.processError(data);
                    },

                    onGetMyTripsOk: function(data) {
                        var bookingInfo = myTripsUtils.retrieveBookingInfoFromToken(tdid, tdo, data);
                        bookingInfo.bookingID = bookingInfo.bookingID || bookingIDInfo;
                        if (Odigeo._.isNumber(bookingInfo.bookingID)) {
                            myTripsUtils.navigateToBooking(bookingInfo, data);
                        } else {
                            if (bookingInfo.error) {
                                widgetLoader.get('myTrips').execute('openLightBoxMsg', bookingInfo.error);
                            }
                            loadMyTrips(data);
                        }
                        const p1 = new Promise((resolve) => widgetLoader.get('itineraryStatus').execute('getAirlineList', resolve))
                            .then((airlineListMap) => {
                                airlineList = airlineListMap;
                                return airlineListMap;
                            });

                        const p2 = new Promise((resolve) => widgetLoader.get('myTrips')
                            .execute('getBookingDetailsForMyTripsItineraryStatusTracking', resolve))
                            .then((alteredBookingDetailsForTracking) => {
                                return {
                                    bookingsToTrack: alteredBookingDetailsForTracking,
                                };
                            });

                        Promise.all([p1, p2]).then((resultsIterable) => {
                            const [airlinesMapList, bookingsToTrack] = resultsIterable;
                            bookingsToTrack.bookingsToTrack.forEach((bookingTotrack) => {
                                itineraryStatusTracking
                                    .trackItineraryStatusOnLoad(bookingTotrack, bookingTotrack.cancelledPNRs, airlinesMapList, true);
                            });
                        });
                    },

                    goToTappedOneTripTracking: function(bookingDetail, previousLabel, action) {
                        const labelUpgrade =
                            itineraryStatusTracking.getMyTripsOnClickScenarioAndPageParams(bookingDetail, bookingDetail.cancelledPNRs, airlineList);
                        trackingUtils.trackEvent(action, `${previousLabel}${labelUpgrade}`);
                    },

                    onShowCanFindBooking: function(categoryBookings) {
                        widgetLoader.get('xsellFindBooking').execute('renderTemplate', categoryBookings);
                    },

                    onHideCanFindBooking: function() {
                        widgetLoader.get('xsellFindBooking').execute('emptyFindBookings');
                    },

                    onChangeCategoryTracking: function(data) {
                        _changeCategoryTracking(data);
                    },

                    onDataTrackNoTrips: function(data) {
                        $myInfo.find('#personal_area_menu').data('track-action', data.action).data('track-category', data.category);
                        widgetLoader.get('downloadAppBanner').execute('dataTrack', data.category);
                    },
                    onLoginExpiration: function() {
                        widgetLoader.get('myTrips').execute('clearEML');
                    },
                    onHideManageMyBookingBox: function() {
                        $manageMyBookingBox.addClass('odf-hidden');
                    },
                    onRequestManageMyBookingToken: function(data) {
                        widgets.getUsersManager().execute('submitUserRequest', {
                            'data': data,
                            'action': 'getManageBookingToken',
                        });
                    },
                    onGetManageBookingToken: function(data) {
                        widgetLoader.get('myTrips').execute('goToManageMyBookingPage', data);
                    },
                    onGetEncryptedTripOk: function(data) {
                        bookingIDInfo = data.bookingDetailDTO.bookingBasicInfo.id;
                        myTripsUtils.requestMyTrips();
                    },
                    onGetEncryptedTripError: function(data) {
                        myTripsUtils.requestMyTrips();
                        widgetLoader.get('myTrips').execute('openLightBoxMsg', data.messageError);
                    },
                },
            });
        Odigeo.Router.eventController.execute();
        widgetLoader.get('myTrips');

        postBookingEventController.init();

        const $personalAreaMenu = $('#personal_area_menu');
        const $personalAreaTitle = $('#personal_area_title');
        const menu = Odigeo.UIElements.menu.enhanceMenu($personalAreaMenu);
        const $manageMyBookingBox = $personalAreaMenu.find('.manage_my_booking_menu');
        const tdid = Odigeo.Session.get('tdid');
        const td = Odigeo.Session.get('td');
        const tdo = Odigeo.Session.get('tdo');
        const endUrl = Odigeo.History.getFragment().split('/')[1];
        const isMyTripDetails = endUrl !== '' && !Odigeo._.isNaN(endUrl);
        let bookingIDInfo;

        const loadMyTrips = function(data) {
            $('#myInfoUserName').text(data.displayName ? data.displayName : '');
            Odigeo.trigger('my-trips:hideCanFindBooking');
            widgetLoader.get('myTrips').execute(data.action, data);
            widgets.getPostBookingBags().execute('clearBagSelections');
            widgets.getPostBookingSeats().execute('clearSeatSelections');
        };

        const _changePageTitle = function() {
            $personalAreaTitle.removeClass('odf-hidden');
            $personalAreaMenu.data('track-action', 'sidebar').data('track-category', 'my_area_trips');
        };

        _changePageTitle('main');
        if (!Odigeo._.isEmpty(td)) {
            Odigeo.Session.remove('td');
            myTripsUtils.requestEncryptedTrip(td);
        } else {
            Odigeo.Session.remove('tdid');
            Odigeo.Session.remove('tdo');
            myTripsUtils.requestMyTrips();
        }

        const _changeCategoryTracking = function(data) {
            widgetLoader.get('downloadAppBanner').execute('trackEventCategory', data);
        };

        if (menu) {
            menu.trigger('changeSelectedMenu', $page.attr('class'));
        }

        Odigeo.once('routeChange', function() {
            if (Odigeo.AB.isManageMyBookingDesktop) {
                $manageMyBookingBox.addClass('odf-hidden');
            }
        });

        // Analytics: virtual page tracking
        if (!isMyTripDetails) {
            trackingUtils.trackPage('mytrips', {
                funnel: false,
            });
        }
        tagManagement.updateDatalayer();
    };
}());
